import { useQuery, keepPreviousData } from '@tanstack/react-query';
import availabilityGridApi from '../services/availabilityGridApi';

export const AVAILABILITY_GRID_KEY = (params) => ['availability', 'grid', params];

/**
 * The availability grid for one window + filter set.
 *
 * Operational data (plan §9): refetched when the tab regains focus and every 90 s while the
 * page is open, so a booking that lands while ops are watching appears without a reload.
 * The previous window stays on screen while the next one loads — paging must not flash an
 * empty board between two full ones (the page dims it while it is a placeholder).
 *
 * `staleTime: 0` — the page's loop is: read a night here → click through to the unit calendar →
 * change it → come back. Any freshness window would serve the pre-change grid on return, the
 * same trap usePricingGuidance.js documents.
 */
export const useAvailabilityGrid = (params) =>
  useQuery({
    queryKey: AVAILABILITY_GRID_KEY(params),
    queryFn: () => availabilityGridApi.getGrid(params),
    staleTime: 0,
    refetchInterval: 90 * 1000,
    refetchOnWindowFocus: true,
    placeholderData: keepPreviousData
  });
